import React, { createContext, ReactNode, useContext, useState } from 'react';

export enum AnalyticsEvent {
  MOBILE_BROWSER_CLOSED = 'mobile_browser_closed',
  SIGN_IN_EXISTENCE_CHECK_STARTED = 'sign_in_existence_check_started',
  SIGN_IN_REQUESTED = 'sign_in_requested',
  SIGN_IN_COMPLETED = 'sign_in_completed',
  SIGN_IN_FAILED = 'sign_in_failed',
  SIGN_UP_REQUESTED = 'sign_up_requested',
  SIGN_UP_COMPLETED = 'sign_up_completed',
  SIGN_UP_FAILED = 'sign_up_failed',
  SIGN_OUT_REQUESTED = 'sign_out_requested',
  SIGN_OUT_COMPLETED = 'sign_out_completed',
  SIGN_OUT_FAILED = 'sign_out_failed',
  GRADE_SELECTION_REQUESTED = 'grade_selection_requested',
  GRADE_SELECTION_COMPLETED = 'grade_selection_completed',
  GRADE_SELECTION_FAILED = 'grade_selection_failed',
  PASSWORD_RESET_REQUESTED = 'password_reset_requested',
  PASSWORD_RESET_REQUEST_COMPLETED = 'password_reset_completed',
  PASSWORD_RESET_REQUEST_FAILED = 'password_reset_failed',
  PASSWORD_RESET_CONFIRMED = 'password_reset_confirmed',
  PASSWORD_RESET_CONFIRMATION_COMPLETED = 'password_reset_confirmation_completed',
  PASSWORD_RESET_CONFIRMATION_FAILED = 'password_reset_confirmation_failed',
  LIBRARY_OPENED = 'library_opened',
  LIBRARY_INTEREST_SELECTION_REQUESTED = 'library_interest_selection_requested',
  LIBRARY_INTEREST_SELECTION_COMPLETED = 'library_interest_selection_completed',
  LIBRARY_INTEREST_SELECTION_FAILED = 'library_interest_selection_failed',
  STORY_BUILDER_OPENED = 'story_builder_opened',
  STORY_BUILDER_STEP_COMPLETED = 'story_builder_step_completed',
  STORY_BUILDER_GENERATION_REQUESTED = 'story_builder_generation_requested',
  STORY_BUILDER_GENERATION_STARTED = 'story_builder_generation_started',
  STORY_BUILDER_GENERATION_REQUEST_FAILED = 'story_builder_generation_request_failed',
  STORY_BUILDER_CONTINUATION_REQUEST_FAILED = 'story_builder_continuation_request_failed',
  STORY_BUILDER_GENERATION_FAILED = 'story_builder_generation_failed',
  STORY_BUILDER_GENERATION_WAIT = 'story_builder_generation_wait',
  STORY_BUILDER_GENERATION_COMPLETED = 'story_builder_generation_completed',
  BOOK_BUILDER_OPENED = 'book_builder_opened',
  BOOK_BUILDER_STEP_COMPLETED = 'book_builder_step_completed',
  BOOK_BUILDER_GENERATION_REQUESTED = 'book_builder_generation_requested',
  BOOK_BUILDER_GENERATION_STARTED = 'book_builder_generation_started',
  BOOK_BUILDER_GENERATION_REQUEST_FAILED = 'book_builder_generation_request_failed',
  BOOK_BUILDER_GENERATION_FAILED = 'book_builder_generation_failed',
  BOOK_BUILDER_GENERATION_WAIT = 'book_builder_generation_wait',
  BOOK_BUILDER_GENERATION_COMPLETED = 'book_builder_generation_completed',
  STORY_OPENED = 'story_opened',
  STORY_READING_COMPLETED = 'story_reading_completed',
  STORY_ANSWERED_FIRST_QUESTION = 'story_answered_first_question',
  STORY_ANSWERED_ALL_GUIDING_QUESTIONS = 'story_answered_all_guiding_questions',
  STORY_ANSWERED_ALL_QUESTIONS = 'story_answered_all_questions',
  STORY_MOVED_TO_NEXT = 'story_moved_to_next',
  REDEEM_REWARDS_OPENED = 'redeem_rewards_opened',
  REDEEM_REWARDS_REQUESTED = 'redeem_rewards_requested',
  REDEEM_REWARDS_REQUEST_COMPLETED = 'redeem_rewards_request_completed',
  REDEEM_REWARDS_REQUEST_FAILED = 'redeem_rewards_request_failed',
  USER_PROFILE_OPENED = 'user_profile_opened',
  USER_PROFILE_EDIT_INFO_REQUESTED = 'user_profile_edit_info_requested',
  USER_PROFILE_EDIT_INFO_COMPLETED = 'user_profile_edit_info_completed',
  USER_PROFILE_EDIT_INFO_FAILED = 'user_profile_edit_info_failed',
  USER_PROFILE_EDIT_IMAGE_REQUESTED = 'user_profile_edit_image_requested',
  USER_PROFILE_EDIT_IMAGE_COMPLETED = 'user_profile_edit_image_completed',
  USER_PROFILE_EDIT_IMAGE_FAILED = 'user_profile_edit_image_failed',
  USER_ACHIEVEMENT_COMPLETED = 'user_achievement_completed',
  TRIAL_START_REQUESTED = 'trial_start_requested',
  PURCHASE_VERIFICATION_REQUESTED = 'purchase_verification_requested',
  PURCHASE_VERIFICATION_COMPLETED = 'purchase_verification_completed',
  PLAN_SELECTION_OPENED = 'plan_selection_opened',
  PAYMENT_INITIATED = 'payment_initiated',
  PAYMENT_APPROVED = 'payment_approved',
  PAYMENT_VERIFIED = 'payment_verified',
  PAYMENT_FINALIZED = 'payment_finalized',
  PAYMENT_ERROR = 'payment_error',
  MONTHLY_SUBSCRIPTION_ACTIVATED = 'monthly_subscription_activated',
  ANNUAL_SUBSCRIPTION_ACTIVATED = 'annual_subscription_activated',
  PARENT_DASHBOARD_OPENED = 'parent_dashboard_opened',
  IMPERSONATE_REQUESTED = 'impersonate_requested',
  IMPERSONATE_COMPLETED = 'impersonate_completed',
  IMPERSONATE_FAILED = 'impersonate_failed',
  STUDENT_ACCOUNT_CREATE_REQUESTED = 'student_account_create_requested',
  STUDENT_ACCOUNT_CREATE_COMPLETED = 'student_account_create_completed',
  STUDENT_ACCOUNT_CREATE_FAILED = 'student_account_create_failed',
  STUDENT_ACCOUNT_DELETE_REQUESTED = 'student_account_delete_requested',
  STUDENT_ACCOUNT_DELETE_COMPLETED = 'student_account_delete_completed',
  STUDENT_ACCOUNT_DELETE_FAILED = 'student_account_delete_failed',
  READING_CIRCLES_DASHBOARD_OPENED = 'reading_circles_dashboard_opened',
  READING_CIRCLE_OPENED = 'reading_circle_opened',
  READING_CIRCLE_CREATE_REQUESTED = 'reading_circle_create_requested',
  READING_CIRCLE_CREATE_COMPLETED = 'reading_circle_create_completed',
  READING_CIRCLE_CREATE_FAILED = 'reading_circle_create_failed',
  READING_CIRCLE_UPDATE_REQUESTED = 'reading_circle_update_requested',
  READING_CIRCLE_UPDATE_COMPLETED = 'reading_circle_update_completed',
  READING_CIRCLE_UPDATE_FAILED = 'reading_circle_update_failed',
  READING_CIRCLE_INVITE_REQUESTED = 'reading_circle_invite_requested',
  READING_CIRCLE_INVITE_COMPLETED = 'reading_circle_invite_completed',
  READING_CIRCLE_INVITE_FAILED = 'reading_circle_invite_failed',
  READING_CIRCLE_ACCEPT_INVITATION_REQUESTED = 'reading_circle_accept_invitation_requested',
  READING_CIRCLE_ACCEPT_INVITATION_COMPLETED = 'reading_circle_accept_invitation_completed',
  READING_CIRCLE_ACCEPT_INVITATION_FAILED = 'reading_circle_accept_invitation_failed',
  READING_CIRCLE_JOIN_MY_STUDENT_REQUESTED = 'reading_circle_join_my_student_requested',
  READING_CIRCLE_JOIN_MY_STUDENT_COMPLETED = 'reading_circle_join_my_student_completed',
  READING_CIRCLE_JOIN_MY_STUDENT_FAILED = 'reading_circle_join_my_student_failed',
  READING_CIRCLE_WITHDRAW_MY_STUDENT_REQUESTED = 'reading_circle_withdraw_my_student_requested',
  READING_CIRCLE_WITHDRAW_MY_STUDENT_COMPLETED = 'reading_circle_withdraw_my_student_completed',
  READING_CIRCLE_WITHDRAW_MY_STUDENT_FAILED = 'reading_circle_withdraw_my_student_failed',
  READING_CIRCLE_REMOVE_STUDENT_REQUESTED = 'reading_circle_remove_student_requested',
  READING_CIRCLE_REMOVE_STUDENT_COMPLETED = 'reading_circle_remove_student_completed',
  READING_CIRCLE_REMOVE_STUDENT_FAILED = 'reading_circle_remove_student_failed',
  READING_CIRCLE_REACTION_ADD_REQUESTED = 'reading_circle_reaction_add_requested',
  READING_CIRCLE_REACTION_ADD_COMPLETED = 'reading_circle_reaction_add_completed',
  READING_CIRCLE_REACTION_ADD_FAILED = 'reading_circle_reaction_add_failed',
  READING_CIRCLE_REACTION_REMOVE_REQUESTED = 'reading_circle_reaction_remove_requested',
  READING_CIRCLE_REACTION_REMOVE_COMPLETED = 'reading_circle_reaction_remove_completed',
  READING_CIRCLE_REACTION_REMOVE_FAILED = 'reading_circle_reaction_remove_failed',
  READING_CIRCLE_FEED_LOAD_REQUESTED = 'reading_circle_feed_load_requested',
  READING_CIRCLE_FEED_LOAD_COMPLETED = 'reading_circle_feed_load_completed',
  READING_CIRCLE_FEED_LOAD_FAILED = 'reading_circle_feed_load_failed',
  READING_CIRCLE_LEADERBOARD_LOAD_REQUESTED = 'reading_circle_leaderboard_load_requested',
  READING_CIRCLE_LEADERBOARD_LOAD_COMPLETED = 'reading_circle_leaderboard_load_completed',
  READING_CIRCLE_LEADERBOARD_LOAD_FAILED = 'reading_circle_leaderboard_load_failed',
  VOUCHER_REDEMPTION_REQUESTED = 'voucher_redemption_requested',
  VOUCHER_REDEMPTION_COMPLETED = 'voucher_redemption_completed',
  VOUCHER_REDEMPTION_FAILED = 'voucher_redemption_failed',
  STORY_LINK_SHARED = 'story_link_shared',
  SHARED_STORY_VIEWED = 'shared_story_viewed',
  HEADER_LOGO_CLICKED = 'header_logo_clicked',
  SIGNUP_PROMPT_CTA_CLICKED = 'signup_prompt_cta_clicked',
  PARENT_STORY_READ_REQUESTED = 'parent_story_read_requested',
  SHARED_STORY_COMPLETED = 'shared_story_completed',
  CHAPTER_BUILDER_GENERATION_STARTED = 'chapter_builder_generation_started',
  CHAPTER_BUILDER_GENERATION_WAIT = 'chapter_builder_generation_wait',
  CHAPTER_BUILDER_GENERATION_COMPLETED = 'chapter_builder_generation_completed',
  CHAPTER_BUILDER_GENERATION_FAILED = 'chapter_builder_generation_failed',
  CHAPTER_BUILDER_GENERATION_REQUESTED = 'chapter_builder_generation_requested',
  BOOK_COVER_GENERATED = 'book_cover_generated',
  BOOK_PUBLISHED = 'book_published',
  BOOK_LINK_SHARED = 'book_link_shared',
  STUDENT_ACCOUNT_EDIT_REQUESTED = 'student_account_edit_requested',
  STUDENT_ACCOUNT_EDIT_COMPLETED = 'student_account_edit_completed',
  STUDENT_ACCOUNT_EDIT_FAILED = 'student_account_edit_failed',
  TEXT_TO_SPEECH_STARTED = 'text_to_speech_started',
  TEXT_TO_SPEECH_STOPPED = 'text_to_speech_stopped',
  TEXT_TO_SPEECH_PAUSED = 'text_to_speech_paused',
  TEXT_TO_SPEECH_ERROR = 'text_to_speech_error',
  STATS_CLICKED = 'stats_clicked',
  XP_CLICKED = 'xp_clicked',
  DILEMMA_CHOICE_CREATION_REQUESTED = 'dilemma_choice_creation_requested',
  DILEMMA_CHOICE_CREATION_FAILED = 'dilemma_choice_creation_failed',
  DILEMMA_CHOICE_CREATION_COMPLETED = 'dilemma_choice_creation_completed',
  DILEMMA_CHOICE_SUBMITTED = 'dilemma_choice_submitted',
  DILEMMA_CHOICES_SELECTION_REQUESTED = 'dilemma_choices_selection_requested',
  DILEMMA_CHOICES_SELECTION_FAILED = 'dilemma_choices_selection_failed',
  DILEMMA_CHOICES_SELECTION_COMPLETED = 'dilemma_choices_selection_completed',
  BOOK_BUILDER_GENERATION_REQUEST_COMPLETED = 'book_builder_generation_request_completed',
  BOOK_COVER_GENERATION_REQUESTED = 'book_cover_generation_requested',
  BOOK_COVER_GENERATION_FAILED = 'book_cover_generation_failed',
  BOOK_COVER_GENERATION_COMPLETED = 'book_cover_generation_completed',
  BOOK_PUBLISH_REQUESTED = 'book_publish_requested',
  BOOK_PUBLISH_FAILED = 'book_publish_failed',
  BOOK_PUBLISH_COMPLETED = 'book_publish_completed',
  QUIZ_QUESTION_ANSWERED = 'quiz_question_answered',
  QUIZ_QUESTION_ANSWERED_FAILED = 'quiz_question_answered_failed',
  BOOK_VIDEO_WATCH_STARTED = 'book_video_watch_started',
  BOOK_VIDEO_WATCH_COMPLETED = 'book_video_watch_completed',
  BOOK_VIDEO_WATCH_PAUSED = 'book_video_watch_paused',
  BOOK_VIDEO_WATCH_RESUMED = 'book_video_watch_resumed',
  BOOK_VIDEO_WATCH_STOPPED = 'book_video_watch_stopped',
  BOOK_VIDEO_WATCH_ERROR = 'book_video_watch_error',
  BOOK_BUILDER_COAUTHOR_SELECTED = 'book_builder_coauthor_selected',
}

export interface AnalyticsPlatform {
  getId: () => string;
  isEventSupported: (event: AnalyticsEvent) => boolean;
  trackEvent: (event: AnalyticsEvent, metadata?: any) => Promise<void>;
  identifyUser: (userId: string, metadata?: any) => void;
  resetUser: () => void;
}

interface AnalyticsContextType {
  trackEvent: (event: AnalyticsEvent, metadata?: any) => Promise<void>;
  registerAnalyticsPlatform: (platform: AnalyticsPlatform) => void;
  identifyUser: (userId: string, metadata?: any) => void;
  resetUser: () => void;
  analyticsPlatforms?: AnalyticsPlatform[];
}

const AnalyticsContext = createContext<AnalyticsContextType | undefined>(
  undefined,
);

interface AnalyticsProviderProps {
  children: ReactNode;
}

export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({
  children,
}) => {
  let [platforms, setPlatforms] = useState<AnalyticsPlatform[]>([]);

  const trackEvent = async (
    eventName: AnalyticsEvent,
    metadata?: any,
  ): Promise<void> => {
    await Promise.all(
      platforms
        .filter((platform) => platform.isEventSupported(eventName))
        .map((platform) => platform.trackEvent(eventName, metadata)),
    );
  };

  const identifyUser = (userId: string, metadata?: any) => {
    for (const platform of platforms) {
      platform.identifyUser(userId, metadata);
    }
  };

  const resetUser = () => {
    for (const platform of platforms) {
      platform.resetUser();
    }
  };

  const registerAnalyticsPlatform = (platform: AnalyticsPlatform) => {
    if (platforms.some((p) => p.getId() === platform.getId())) {
      // (don't spam, since we're registering them outside effect)
      // console.warn('Analytics Platform already registered, skipping');
      return;
    }

    const newPlatforms = [...platforms, platform];
    setPlatforms(newPlatforms);
    // This is to make sure that tracking starts working even before state is updated
    platforms = newPlatforms;
  };

  return (
    <AnalyticsContext.Provider
      value={{
        trackEvent,
        identifyUser,
        resetUser,
        registerAnalyticsPlatform,
        analyticsPlatforms: platforms,
      }}
    >
      {children}
    </AnalyticsContext.Provider>
  );
};

export const useAnalytics = (): AnalyticsContextType => {
  const context = useContext(AnalyticsContext);
  if (context === undefined) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }
  return context;
};
